import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import i18n from './i18n';
//import * as serviceWorker from './serviceWorker.js';
// import { subscribeUser } from './subscription';
import { icons } from './assets/icons';
import ToasterComponent from './reusable/toaster-container';
import store from './store';

React.icons = icons;

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <ToasterComponent />
      <App />
    </I18nextProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.register();/
// subscribeUser();
